var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStash = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 4.33333V3C10.625 2.44772 10.1773 2 9.625 2H6.375C5.82272 2 5.375 2.44772 5.375 3V4.33333",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78087 14H5.63896C4.85516 14 4.2035 13.3966 4.14339 12.6151L3.50635 4.33337",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 4.33333H2.6665",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 14.6666C9.00965 14.6666 7.6665 13.3235 7.6665 11.6666C7.6665 10.0098 9.00965 8.66663 10.6665 8.66663C12.3234 8.66663 13.6665 10.0098 13.6665 11.6666C13.6665 12.4623 13.3504 13.2253 12.7878 13.7879C12.2252 14.3506 11.4622 14.6666 10.6665 14.6666",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11.6667C11.4999 11.6851 11.485 11.7001 11.4666 11.7C11.4482 11.7 11.4333 11.6851 11.4333 11.6667C11.4333 11.6483 11.4482 11.6334 11.4666 11.6334C11.485 11.6334 11.4999 11.6483 11.5 11.6667V11.6667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89987 11.6667C9.89985 11.6851 9.88492 11.7001 9.86652 11.7C9.84811 11.7 9.8332 11.6851 9.8332 11.6667C9.8332 11.6483 9.84811 11.6334 9.86652 11.6334C9.88492 11.6334 9.89985 11.6483 9.89987 11.6667V11.6667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.131 9.04737L12.4936 4.33337",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStash);
export default ForwardRef;